import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import KycRequired from '../../../components/Cards/KycRequired';
import { Modal } from '../../../components/Modal/Modal';
import KycInformationModal from '../../../components/Modal/ModalActions/KycInformationModal/KycInformationModal';
import useHiringConflictCount from '../../../hooks/dashboard/driver-list/useHiringConflictCont';
import { useAppSelector } from '../../../redux/store';
import { HIRING_CONFLICTS } from '../../../routes/routeConstants';

const HiringConflict = () => {
  const { hiringConflictCount, loading, conflictCount } =
    useHiringConflictCount();
  const [showKycRequiredModal, setShowKycRequiredModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { kycStatusData } = useAppSelector((state) => state.kycStatusData);

  useEffect(() => {
    if (!loading) {
      hiringConflictCount();
    }
    // eslint-disable-next-line
  }, []);

  const onSubmit = () => {
    if (!['Accepted'].includes(kycStatusData?.kycStatus ?? '')) {
      setShowKycRequiredModal(true);
    } else {
      navigate(`/${HIRING_CONFLICTS}`);
    }
  };

  const successActionFn = () => {
    setShowModal(true);
    setShowKycRequiredModal(false);
  };

  const navigate = useNavigate();
  return (
    <>
      <Container onClick={onSubmit}>
        Hiring Conflicts <Count>{conflictCount ?? 0}</Count>
      </Container>

      <Modal
        showModal={showKycRequiredModal}
        setShowModal={setShowKycRequiredModal}
      >
        <KycRequired
          successActionFn={successActionFn}
          message='You need to complete your KYC to view hiring conflicts'
        />
      </Modal>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <KycInformationModal />
      </Modal>
    </>
  );
};

export default HiringConflict;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #5b91f5;
  border: 1px solid #5b91f5;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
`;

const Count = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #5b91f5;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;
